import { getCompanyListRequest } from '../../../../services/network/search/company';

class CommonCompanySearchService {
    async getCompanySearchList(data) {
        return await getCompanyListRequest(data);
    }
}

export const CompanySearchService = new CommonCompanySearchService();
